/**
 * Sticky "Buy Now" bar behaviour.
 *
 * The buy-buttons block on the product page is pinned to the bottom of the
 * viewport (see blocks/buy-buttons.liquid) to act as a sticky Buy Now bar.
 * This module opens the cart drawer automatically once an add-to-cart
 * request triggered from that bar finishes successfully, using the theme's
 * real cart-update event/promise instead of a fixed timeout so it can't
 * race the network request or fight with the drawer's own toggle button.
 *
 * Scoped to the Cart Drawer Redesign theme only.
 */
import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add') return;

  // Only auto-open the cart drawer when the add-to-cart came from this
  // product page's sticky Buy Now bar. Grid/catalog "Add to cart" buttons
  // (collections, "People also bought", "You may also like", quick-add)
  // use a separate <product-form-component data-card-atc> that is never
  // nested inside .buy-buttons-block, so they are correctly excluded here.
  const target = event.target instanceof Element ? event.target : null;
  if (!target?.closest('.buy-buttons-block')) return;

  const { promise } = event;
  if (!promise || typeof promise.then !== 'function') return;

  promise
    .then((result) => {
      const detail = result && result.detail;
      if (detail && detail.didError) return;

      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    })
    .catch((error) => {
      if (error && error.name !== 'AbortError') {
        console.warn('[sticky-buy-now] cart update promise rejected:', error);
      }
    });
});
